var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDevices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.931,
    height: 16.012,
    viewBox: "0 0 9.931 16.012",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_66581",
    "data-name": "Trazado 66581",
    d: "M10.14,20.042h5.752a1.934,1.934,0,0,0,2.071-2.02V6.05a1.934,1.934,0,0,0-2.071-2.02H10.14A1.956,1.956,0,0,0,8.032,6.05V18.022A1.956,1.956,0,0,0,10.14,20.042Zm.241-1.471a.819.819,0,0,1-.915-.878V6.379a.814.814,0,0,1,.915-.871h5.24a.814.814,0,0,1,.915.871V17.693a.819.819,0,0,1-.915.878H14.187v-.256a.5.5,0,0,0-.527-.534H12.35a.5.5,0,0,0-.527.534v.256Z",
    transform: "translate(-8.032 -4.03)",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.493c30958fa202e194229aa0fa77aa4d.svg";
export { ForwardRef as ReactComponent };